import React from 'react';
import { FINAL_CTA } from '../data/content';
import ScrollReveal from '../components/ScrollReveal';
import MagneticButton from '../components/MagneticButton';
import usePointerVars from '../hooks/usePointerVars';
import useScrollVar from '../hooks/useScrollVar';
import useMotionPrefs from '../hooks/useMotionPrefs';

/* ==================================================================
   FinalCTA
   ------------------------------------------------------------------
   The closing statement. Two slow aurora fields drift behind the
   headline, a third follows the cursor, and the whole block eases
   upward as the section arrives (--hs-p). Two decisions, two buttons.
   ================================================================== */

export default function FinalCTA() {
  const { reduced, pointer } = useMotionPrefs();
  const lightRef = usePointerVars({ disabled: reduced || !pointer });
  const riseRef = useScrollVar({ mode: 'cover', varName: '--hs-p', disabled: reduced, resetValue: 1 });

  return (
    <section className="hs-final" ref={lightRef}>
      <span className="hs-final__aurora hs-final__aurora--a" aria-hidden="true" />
      <span className="hs-final__aurora hs-final__aurora--b" aria-hidden="true" />
      <span className="hs-final__light" aria-hidden="true" />
      <span className="hs-final__grid" aria-hidden="true" />

      <div className="hs-shell hs-final__inner" ref={riseRef}>
        <ScrollReveal as="h2" className="hs-final__title" variant="up">
          {FINAL_CTA.heading}
        </ScrollReveal>
        <ScrollReveal as="p" className="hs-final__sub" variant="up" delay={110}>
          {FINAL_CTA.sub}
        </ScrollReveal>
        <ScrollReveal className="hs-final__ctas" variant="up" delay={190}>
          <MagneticButton to={FINAL_CTA.primary.to} variant="primary" size="xl" strength={9} arrow>
            {FINAL_CTA.primary.label}
          </MagneticButton>
          <MagneticButton to={FINAL_CTA.secondary.to} variant="outline" size="xl" strength={9}>
            {FINAL_CTA.secondary.label}
          </MagneticButton>
        </ScrollReveal>
      </div>
    </section>
  );
}
